const LocalStorageService = {
  set: (key, value, config = {}) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  clear: () => {
    localStorage.clear();
  },
  remove: (key) => {
    localStorage.removeItem(key);
  },
  get: (key, config = {}) => {
    let str = localStorage.getItem(key);
    if (!str) {
      return null;
    }
    try {
      return JSON.parse(str);
    } catch (e) {
      // Corrupted value (e.g. tampered or non-JSON) would otherwise crash
      // every caller on every read — drop it so the app self-heals.
      localStorage.removeItem(key);
      return null;
    }
  },
  updateObject: (key, name, value) => {
    let str = LocalStorageService.get(key);
    if (!str) {
      LocalStorageService.set(key, { [name]: value });
      return;
    } else {
      LocalStorageService.set(key, {
        ...str,
        [name]: value
      });

    }

  }
};

export default LocalStorageService;
